<template>
    <div class="ticket">
        <p class="instructions">
            Open: Enter PIN and turn the knob.<br>
            Close: Turn the knob and wait 2 seconds.
        </p>

        <p class="instructions">
            Always turn the door knob to close your locker.<br>
            Please make sure you don't lose this ticket.
        </p>

        <table>
            <tr v-if="locker.zone">
                <td>Zone</td>
                <td class="value">
                    {{ locker.zone }}
                </td>
            </tr>

            <tr>
                <td>Locker number</td>
                <td class="value">
                    {{ lockerSize }}
                    {{ locker.locker_number }}
                </td>
            </tr>

            <tr>
                <td>PIN code</td>
                <td class="value">
                    {{ locker.code }}
                </td>
            </tr>
        </table>

        <p class="details">
            <template v-if="getPeriodText(period, 'name')">{{ getPeriodText(period, 'name') }} - </template>{{ period.start | moment('ddd D MMMM') }}
        </p>

        <p class="tip">
            Tip! Take a picture and send it to your friends. Make sure to keep your PIN private from others.
        </p>

        <img src="../assets/img/logo-ticket.png" class="logo" alt="Locker Company" @load="loaded">

        <p class="terms">
            By using a locker you automatically accept the terms and conditions from Locker Company.
        </p>
    </div>
</template>

<script>
    import translationMixin from '../mixins/translationMixin';
    import moment from 'moment';

    export default {
        mixins: [translationMixin],

        props: [
            'locker',
            'lockerSize',
            'period',
            'event'
        ],

       /**
        * Make sure ticket is always in English.
        */
        created() {
            moment.locale('en');
        },

        methods: {
            /**
             * Emit loaded event.
             */
            loaded() {
                this.$emit('loaded');
            }
        }
    }
</script>
